import React from 'react';
import OrderEditor from '../common/OrderEditor';
import { billsAPI, vendorsAPI } from '../../services/api';

export default function BillForm() {
  return (
    <OrderEditor
      title="Bill"
      api={billsAPI}
      basePath="/bills"
      partyLabel="Vendor"
      loadParties={() => vendorsAPI.list({})}
      idField="vendor_id"
      nameField="vendor_name"
      dateField="bill_date"
      secondLabel="Due Date"
      secondField="due_date"
      statuses={['Draft', 'Submitted', 'Paid', 'Partial', 'Voided']}
    />
  );
}
